import { render, staticRenderFns } from "./PurchaseMethod.vue?vue&type=template&id=d6bd8f68&"
import script from "./PurchaseMethod.vue?vue&type=script&lang=js&"
export * from "./PurchaseMethod.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports